import css from "styled-jsx/css";
import { rdcUiTheme } from "@rdc-npm/rdc-ui";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";

  .send-message {
    margin-top: 12px;
  }
  .preview-main-content {
    width: 610px;
  }
  .preview-link {
    font-size: 16px;
    font-weight: ${rdcUiTheme.typography.weight.regular};
    color: ${rdcUiTheme.color.text.primary};
    line-height: 24px;
  }
  .review {
    font-size: 16px;
    font-weight: ${rdcUiTheme.typography.weight.regular};
    color: ${rdcUiTheme.color.text.primary};
    line-height: 24px;
  }
  .badge {
    font-size: 14px;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    color: ${rdcUiTheme.color.text.secondary};
    line-height: 20px;
  }
  .profile-details {
    display: flex;
    align-items: center;
    .profile-info {
      padding-left: 24px;
      .ratings {
        font-weight: 500;
        display: flex;
        align-items: center;
        .gray-font {
          color: $gray-light;
          font-size: 16px;
          font-weight: ${rdcUiTheme.typography.weight.medium};
          line-height: 24px;
        }
      }

      .separator-dot {
        margin-left: 5px;
        margin-right: 5px;
        color: #c8c8c8;
      }
    }
    .profile-img {
      height: 116px;
      width: 116px;
      max-width: 100%;
      border-radius: 50%;
    }
    .profile-mobile-icon {
      display: none;
    }
  }
  .rating-section {
    display: flex;
  }
  .stickyspace.column-flex.pt-3 .rating-section {
    display: block;
  }
  /*********** Mobile Responsive ***********/
  @include mobile {
    .rating-section {
      display: block;
    }
    .profile-mobile-icon {
      position: absolute;
      right: 5%;
      list-style-type: none;
      display: block;
    }
    .profile-img {
      width: 92px !important;
      height: 92px !important;
      max-width: initial !important;
    }
  }
  .stickyspace.column-flex .rating-section {
    display: block !important;
  }
`;
